"use strict";
// WARNING: this file contains profanity. The below list of profane words is necessary for this tool to function properly.
// Do not read below this line if you do not wish to be exposed to lots of profane words
Object.defineProperty(exports, "__esModule", { value: true });
exports.profaneWords = void 0;
exports.profaneWords = new Map([
    [
        "en",
        [
            "4r5e",
            "5h1t",
            "5hit",
            "a55",
            "anal",
            "anus",
            "ar5e",
            "arrse",
            "arse",
            "arses",
            "ass",
            "ass-fucker",
            "asses",
            "assfucker",
            "assfukka",
            "asshole",
            "assholes",
            "asswhole",
            "a_s_s",
            "a$$",
            "as$",
            "a$s",
            "b!tch",
            "b00bs",
            "b17ch",
            "b1tch",
            "ballbag",
            "balls",
            "ballsack",
            "bastard",
            "beastial",
            "beastiality",
            "bellend",
            "bestial",
            "bestiality",
            "bi+ch",
            "biatch",
            "bitch",
            "bitchboy",
            "bitcher",
            "bitchers",
            "bitches",
            "bitchin",
            "bitching",
            "bloody",
            "blow job",
            "blowjob",
            "blowjobs",
            "boiolas",
            "bollock",
            "bollok",
            "boner",
            "boob",
            "boobs",
            "booobs",
            "boooobs",
            "booooobs",
            "booooooobs",
            "breasts",
            "buceta",
            "bugger",
            "bullshit",
            "bum",
            "butt",
            "butts",
            "butthole",
            "buttmuch",
            "buttplug",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "cawk",
            "chink",
            "cipa",
            "cl1t",
            "clit",
            "clitoris",
            "clits",
            "cnut",
            "cock",
            "cock-sucker",
            "cockface",
            "cockhead",
            "cockmunch",
            "cockmuncher",
            "cocks",
            "cocksuck",
            "cocksucked",
            "cocksucker",
            "cocksucking",
            "cocksucks",
            "cocksuka",
            "cocksukka",
            "cok",
            "cokmuncher",
            "coksucka",
            "coon",
            "cox",
            "crap",
            "cum",
            "cummer",
            "cumming",
            "cums",
            "cumshot",
            "cunilingus",
            "cunillingus",
            "cunnilingus",
            "cunt",
            "cuntlick",
            "cuntlicker",
            "cuntlicking",
            "cunts",
            "cyalis",
            "cyberfuc",
            "cyberfuck",
            "cyberfucked",
            "cyberfucker",
            "cyberfuckers",
            "cyberfucking",
            "d1ck",
            "damn",
            "dick",
            "dickhead",
            "dildo",
            "dildos",
            "dink",
            "dinks",
            "dirsa",
            "dlck",
            "dog-fucker",
            "doggin",
            "dogging",
            "donkeyribber",
            "doosh",
            "duche",
            "dyke",
            "ejaculate",
            "ejaculated",
            "ejaculates",
            "ejaculating",
            "ejaculatings",
            "ejaculation",
            "ejakulate",
            "f u c k",
            "f u c k e r",
            "f4nny",
            "fag",
            "fagging",
            "faggitt",
            "faggot",
            "faggs",
            "fagot",
            "fagots",
            "fags",
            "fanny",
            "fannyflaps",
            "fannyfucker",
            "fanyy",
            "fatass",
            "fcuk",
            "fcuker",
            "fcuking",
            "feck",
            "fecker",
            "felching",
            "fellate",
            "fellatio",
            "fingerfuck",
            "fingerfucked",
            "fingerfucker",
            "fingerfuckers",
            "fingerfucking",
            "fingerfucks",
            "fistfuck",
            "fistfucked",
            "fistfucker",
            "fistfuckers",
            "fistfucking",
            "fistfuckings",
            "fistfucks",
            "flange",
            "fook",
            "fooker",
            "fuck",
            "fucka",
            "fucked",
            "fucker",
            "fuckers",
            "fuckhead",
            "fuckheads",
            "fuckin",
            "fucking",
            "fuckings",
            "fuckingshitmotherfucker",
            "fuckme",
            "fucks",
            "fuckwhit",
            "fuckwit",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fuker",
            "fukker",
            "fukkin",
            "fuks",
            "fukwhit",
            "fukwit",
            "fux",
            "fux0r",
            "f_u_c_k",
            "gangbang",
            "gangbanged",
            "gangbangs",
            "gaylord",
            "gaysex",
            "goatse",
            "god-dam",
            "god-damned",
            "goddamn",
            "goddamned",
            "hardcoresex",
            "headass",
            "hoar",
            "hoare",
            "hoer",
            "hoes",
            "homo",
            "hore",
            "horniest",
            "horny",
            "hotsex",
            "jack-off",
            "jackoff",
            "jap",
            "jerk-off",
            "jism",
            "jiz",
            "jizm",
            "jizz",
            "kawk",
            "knobead",
            "knobed",
            "knobend",
            "knobhead",
            "knobjocky",
            "knobjokey",
            "kock",
            "kondum",
            "kondums",
            "kum",
            "kummer",
            "kumming",
            "kums",
            "kunilingus",
            "l3i+ch",
            "l3itch",
            "labia",
            "lust",
            "lusting",
            "m0f0",
            "m0fo",
            "m45terbate",
            "ma5terb8",
            "ma5terbate",
            "masochist",
            "master-bate",
            "masterb8",
            "masterbat*",
            "masterbat3",
            "masterbate",
            "masterbation",
            "masterbations",
            "masturbate",
            "mo-fo",
            "mof0",
            "mofo",
            "mothafuck",
            "mothafucka",
            "mothafuckas",
            "mothafuckaz",
            "mothafucked",
            "mothafucker",
            "mothafuckers",
            "mothafuckin",
            "mothafucking",
            "mothafuckings",
            "mothafucks",
            "motherfuck",
            "motherfucked",
            "motherfucker",
            "motherfuckers",
            "motherfuckin",
            "motherfucking",
            "motherfuckings",
            "motherfuckka",
            "motherfucks",
            "muff",
            "muthafecker",
            "muthafuckker",
            "mutherfucker",
            "n1gga",
            "n1gger",
            "nazi",
            "nigg3r",
            "nigg4h",
            "nigga",
            "niggah",
            "niggas",
            "niggaz",
            "nigger",
            "niggers",
            "nob",
            "nob jokey",
            "nobhead",
            "nobjocky",
            "nobjokey",
            "numbnuts",
            "nutsack",
            "orgasim",
            "orgasims",
            "orgasm",
            "orgasms",
            "p0rn",
            "pawn",
            "pecker",
            "penis",
            "penisfucker",
            "phonesex",
            "phuck",
            "phuk",
            "phuked",
            "phuking",
            "phukked",
            "phukking",
            "phuks",
            "phuq",
            "pigfucker",
            "pimpis",
            "piss",
            "pissed",
            "pisser",
            "pissers",
            "pisses",
            "pissflaps",
            "pissin",
            "pissing",
            "pissoff",
            "poop",
            "porn",
            "porno",
            "pornography",
            "pornos",
            "prick",
            "pricks",
            "pron",
            "pube",
            "pusse",
            "pussi",
            "pussies",
            "pussy",
            "pussys",
            "rectum",
            "retard",
            "rimjaw",
            "rimming",
            "s hit",
            "s.o.b.",
            "sadist",
            "schlong",
            "screwing",
            "scroat",
            "scrote",
            "scrotum",
            "semen",
            "sex",
            "sh!+",
            "sh!t",
            "sh1t",
            "shag",
            "shagger",
            "shaggin",
            "shagging",
            "shemale",
            "shi+",
            "shit",
            "shitdick",
            "shite",
            "shited",
            "shitey",
            "shitfuck",
            "shitfull",
            "shithead",
            "shiting",
            "shitings",
            "shits",
            "shitted",
            "shitter",
            "shitters",
            "shitting",
            "shittings",
            "shitty",
            "skank",
            "slut",
            "sluts",
            "smegma",
            "smut",
            "snatch",
            "son-of-a-bitch",
            "spac",
            "spunk",
            "s_h_i_t",
            "t1tt1e5",
            "t1tties",
            "teets",
            "teez",
            "testical",
            "testicle",
            "tit",
            "titfuck",
            "tits",
            "titt",
            "tittie5",
            "tittiefucker",
            "titties",
            "tittyfuck",
            "tittywank",
            "titwank",
            "tosser",
            "turd",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "twunt",
            "twunter",
            "v14gra",
            "v1gra",
            "vagina",
            "viagra",
            "vulva",
            "w00se",
            "wang",
            "wank",
            "wanker",
            "wanky",
            "whoar",
            "whore",
            "willies",
            "willy",
        ],
    ],
    [
        "ar",
        [
            "4r5e",
            "5h1t",
            "5hit",
            "a55",
            "anal",
            "anus",
            "ar5e",
            "الحصان",
            "المؤخرات",
            "مؤخرة",
            "الوغد",
            "الحمير",
            "assfukka",
            "أحمق",
            "حمقى",
            "الأحمق",
            "دولار",
            "كدولارات",
            "(ب)",
            "b00bs",
            "b17ch",
            "b1tch",
            "الكرة",
            "الكرات",
            "كرات",
            "الوحشية",
            "الجرس",
            "الأفضلية",
            "b+ch",
            "biatch",
            "الكلبة",
            "الكلبات",
            "العاهرات",
            "اللعنة",
            "blow job",
            "عمل فاسد",
            "أعمال تفجيرية",
            "boiolas",
            "هراء",
            "bollok",
            "العظام",
            "صدر",
            "الثدي",
            "البوق",
            "عصيان",
            "البوووب",
            "buceta",
            "حشرة",
            "bum",
            "buttplug",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "مقهى",
            "cipa",
            "cl1t",
            "clit",
            "clitoris",
            "clits",
            "cnut",
            "قضيب",
            "وغد",
            "وجهك",
            "القضيب",
            "كوكر",
            "أيها الوغد",
            "سحقًا",
            "صراخ",
            "cocksuka",
            "cocksukka",
            "كوك",
            "cokmuncher",
            "كوكاكوتا",
            "coon",
            "كوكس",
            "حثالة",
            "cummer",
            "الطهي",
            "cumshot",
            "cunilingus",
            "cunillingus",
            "cunnilingus",
            "cuntlick",
            "النقر",
            "العبث",
            "الحمقى",
            "cyalis",
            "الإنترنت(ج)",
            "الفضاء الإلكتروني",
            "الملاعين السيبرانيين",
            "تسلل عبر الإنترنت",
            "d1ck",
            "dildo",
            "dildos",
            "دينك",
            "dirsa",
            "♪",
            "الكلب اللعين",
            "الكلب",
            "حبوب منع الحمل",
            "doosh",
            "duche",
            "dyke",
            "الإيجاز",
            "ejaculated",
            "الجزيئات",
            "ejaculating",
            "الهرجات",
            "القذف",
            "ejakulate",
            "f u c k",
            "f u c k e r",
            "f4nny",
            "fag",
            "زائفة",
            "الشاذ",
            "الشواذ",
            "fagot",
            "fagots",
            "الكلاب",
            "فاني",
            "fannyflaps",
            "الملاعين",
            "الخيال",
            "الدهون",
            "fcuk",
            "متعهد",
            "الحضانات",
            "feck",
            "فاسد",
            "المهرجان",
            "سقط",
            "fellatio",
            "قبضة لعينة",
            "flange",
            "fook",
            "fooker",
            "مارس الجنس مع",
            "اللعين",
            "سخيف",
            "أيها اللعين",
            "fudge packer",
            "حمأة",
            "فوك",
            "فوكر",
            "fukkin",
            "صمامات",
            "فوكوهي",
            "فوكويت",
            "الثعلب",
            "fux0r",
            "gangbang",
            "العصابات",
            "مثلي الجنس",
            "الماعز",
            "يا إلهي",
            "صلبة",
            "الرأس",
            "hoar",
            "hoare",
            "hoer",
            "hoes",
            "homo",
            "hore",
            "الأشقر",
            "مثارة",
            "مثير",
            "(جاك أوف)",
            "(جاك)",
            "jap",
            "jiz",
            "jizm",
            "jizz",
            "kawk",
            "knobead",
            "حبس",
            "knobend",
            "knobhead",
            "knobjocky",
            "knobjokey",
            "kondum",
            "الكوندوم",
            "kum",
            "kummer",
            "الكم",
            "kums",
            "kunilingus",
            "l3i+ch",
            "l3itch",
            "المختبرات",
            "شهوة",
            "الإغراء",
            "m0f",
            "m0fo",
            "m45terbate",
            "ma5terb8",
            "الماجستير",
            "مسوخ",
            "درجة الماجستير",
            "الماجستير(ب)",
            "المناقشة العامة*",
            "المناقشة الرئيسية 3",
            "سيدي",
            "التحفة",
            "الاستمناء",
            "mo-fo",
            "mof0",
            "mofo",
            "موثا",
            "mothafucka",
            "mothafuckas",
            "mothafuckaz",
            "مضاجعة",
            "mothafuckin",
            "الأوغاد",
            "لعين",
            "muff",
            "muthafecker",
            "ملاعين",
            "n1gga",
            "n1gger",
            "نازي",
            "nigg3r",
            "nigg4h",
            "زنجي",
            "الزنوج",
            "nob",
            "nob jokey",
            "nobhead",
            "نابوكي",
            "nobjokey",
            "الراهبات",
            "مجنون",
            "النشوة",
            "الأورام",
            "p0rn",
            "الرهن",
            "بيكر",
            "الهواتف الجنسية",
            "phuck",
            "phuk",
            "رشاش",
            "رهبان",
            "phukked",
            "الفوكة",
            "phuks",
            "phuq",
            "القواد",
            "بول",
            "سكران غاضب",
            "البول",
            "تبول",
            "poop",
            "porn",
            "porno",
            "المواد الإباحية",
            "pornos",
            "الخوخ",
            "pron",
            "حانة",
            "نقية",
            "pussi",
            "الجبناء",
            "جبان",
            "إعادة التشكيل",
            "المتخلفون",
            "rimjaw",
            "قذف",
            "s hit",
            "s.o.b.",
            "سادي",
            "schlong",
            "scroat",
            "scrote",
            "scrotum",
            "semen",
            "الجنس",
            "ش",
            "sh1t",
            "shag",
            "شجر",
            "shaggin",
            "shemale",
            "shi+",
            "القرف",
            "skank",
            "عاهرة",
            "عاهرات",
            "smegma",
            "smut",
            "snatch",
            "ابن العاهرة",
            "spac",
            "سافل",
            "t1tt1e5",
            "t1tties",
            "teets",
            "teez",
            "اختباري",
            "خصية",
            "tit",
            "أيها الحقير",
            "tittie5",
            "tittywank",
            "titwank",
            "toser",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "توان",
            "v14gra",
            "v1gra",
            "vagina",
            "viagra",
            "vulva",
            "w00se",
            "وانغ",
            "wank",
            "wanker",
            "wanky",
            "الويلات",
            "ويلي",
        ],
    ],
    [
        "de",
        [
            "4r5e",
            "5h1t",
            "5hit",
            "a55",
            "anal",
            "anus",
            "ar5e",
            "arrse",
            "arse",
            "arses",
            "arsch",
            "arschficker",
            "esel",
            "assfukka",
            "arschloch",
            "arschlöcher",
            "arschganz",
            "a$$",
            "in %",
            "a$s",
            "b.tch",
            "b00bs",
            "b17ch",
            "b1tch",
            "kugelbeutel",
            "eier",
            "bälle",
            "bastard",
            "beastial",
            "beastialität",
            "glocke",
            "bestial",
            "bestialität",
            "bi+ch",
            "biatch",
            "schlampe",
            "hündchen",
            "metzger",
            "schlampen",
            "bitchin",
            "bitching",
            "verdammt",
            "blow job",
            "blasen",
            "boiolas",
            "bollock",
            "bollok",
            "knochen",
            "titten",
            "brüste",
            "buhn",
            "boooobs",
            "boooooobs",
            "buceta",
            "fehler",
            "schwachsinn",
            "bum",
            "hintern",
            "buttmuch",
            "buttplug",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "kacke",
            "chink",
            "cipa",
            "cl1t",
            "klitoris",
            "cnut",
            "schwanz",
            "schwanzsauger",
            "schwanzkopf",
            "schwanzlutscher",
            "hahnmacher",
            "schwänze",
            "kokos",
            "kokmuncher",
            "koksucka",
            "coon",
            "cox",
            "mist",
            "cum",
            "kümmel",
            "cumming",
            "cums",
            "cumshot",
            "cunilingus",
            "cunillingus",
            "cunnilingus",
            "fotze",
            "cuntlicker",
            "cuntlicking",
            "stiche",
            "cyalis",
            "cyberfuc",
            "cyberfuck",
            "cyberfickt",
            "cyberfucker",
            "cyberficker",
            "cyberficken",
            "d1ck",
            "dildo",
            "dildos",
            "dink",
            "dinks",
            "dirsa",
            "dlck",
            "hundeficker",
            "doggin",
            "hunde",
            "eselibber",
            "doosh",
            "duche",
            "dyke",
            "ejakulat",
            "ejakuliert",
            "ejaculate",
            "ejakulation",
            "f u c k",
            "f u c k e r",
            "f4nny",
            "schwuchtel",
            "schwuchteln",
            "fagot",
            "fanny",
            "fannyflaps",
            "fannyfucker",
            "phantasievoll",
            "fettass",
            "fcuk",
            "fcuker",
            "fcuking",
            "feck",
            "fecker",
            "felching",
            "flat",
            "fellatio",
            "fingerfick",
            "fingerfickt",
            "fingerficker",
            "fingerficken",
            "fistfuck",
            "fistfickt",
            "fistfucker",
            "fistficken",
            "scheiße",
            "flansch",
            "fook",
            "fooker",
            "fick",
            "fucka",
            "gefickt",
            "wichser",
            "scheißkerle",
            "scheißkerl",
            "fick mich",
            "ficks",
            "fuckwit",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fuker",
            "fukker",
            "fokkin",
            "fuks",
            "fukwhit",
            "fukwit",
            "fux",
            "fux0r",
            "gangbang",
            "gangbanged",
            "gangbangs",
            "gaylord",
            "gaysex",
            "ziegen",
            "gott-dam",
            "hardcoresex",
            "headass",
            "hor",
            "hoare",
            "hoer",
            "huhn",
            "homo",
            "hore",
            "horniest",
            "geil",
            "hotsex",
            "ausleger",
            "knüppel",
            "jap",
            "idiot",
            "jisma",
            "jiz",
            "jizm",
            "jizz",
            "kawk",
            "knospead",
            "geknallt",
            "knaufende",
            "knopfkopf",
            "knospen",
            "knowjokey",
            "kock",
            "kondum",
            "kum",
            "kummer",
            "kumming",
            "kums",
            "kunilingus",
            "l3i+ch",
            "l3itch",
            "labia",
            "lust",
            "lustig",
            "m0f0",
            "m0fo",
            "m45terbat",
            "ma5terb8",
            "ma5terbat",
            "masochist",
            "master-bate",
            "masterb8",
            "masterbat*",
            "masterbat3",
            "masterbat",
            "masterbation",
            "masterbationen",
            "masturbieren",
            "mo-fo",
            "mof0",
            "mofo",
            "mothafuck",
            "mothafucka",
            "mothafuckas",
            "mothafuckaz",
            "mottafucked",
            "mothafucker",
            "mothafuckin",
            "mothafucking",
            "mothafuckings",
            "mothafucks",
            "verfickt",
            "muff",
            "muthafecker",
            "muthafuckker",
            "mutherfucker",
            "n1gga",
            "n1gger",
            "nazi",
            "nigg3r",
            "nigg4h",
            "nigga",
            "niggas",
            "niggaz",
            "nigger",
            "nob",
            "nob jokey",
            "nobhead",
            "nobjocky",
            "nobjokey",
            "nüsse",
            "nussack",
            "orgasim",
            "orgasime",
            "orgasmus",
            "orgasmen",
            "p0rn",
            "pfoten",
            "pecker",
            "penis",
            "penisfucker",
            "telefonsex",
            "phuck",
            "phuk",
            "phuking",
            "phukked",
            "phukking",
            "phuks",
            "phuq",
            "schweinefucker",
            "pimpis",
            "pisse",
            "pissed",
            "pisser",
            "pissflaps",
            "pissin",
            "pissen",
            "pisseff",
            "poop",
            "porno",
            "pornografie",
            "pornos",
            "pricks",
            "pron",
            "pube",
            "pusse",
            "pussi",
            "muschis",
            "muschi",
            "pussys",
            "rektum",
            "verzögert",
            "rimjaw",
            "felgen",
            "s hit",
            "s.o.b.",
            "sadist",
            "schlong",
            "schrauben",
            "skroat",
            "skrote",
            "skrotum",
            "samen",
            "geschlecht",
            "sh!+",
            "sh!t",
            "sh1t",
            "shag",
            "shagger",
            "shaggin",
            "transen",
            "shi+",
            "shit",
            "shited",
            "schlitten",
            "scheißkopf",
            "shitter",
            "splitter",
            "scherben",
            "shank",
            "smegma",
            "smut",
            "snatch",
            "spac",
            "spunk",
            "t1tt1e5",
            "t1tties",
            "teets",
            "teez",
            "hoden",
            "tit",
            "titfuck",
            "titt",
            "tittie5",
            "tittiefucker",
            "tittyfuck",
            "tittywank",
            "titwank",
            "tosser",
            "dord",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "twunt",
            "twunter",
            "v14gra",
            "v1gra",
            "vagina",
            "viagra",
            "vulva",
            "w00se",
            "wang",
            "wank",
            "wahnsinn",
            "hure",
            "willies",
            "willy",
        ],
    ],
    [
        "es",
        [
            "4r5e",
            "5h1t",
            "5hit",
            "a55",
            "anal",
            "aus",
            "ar5e",
            "culo",
            "culos",
            "culo de mierda",
            "idiota",
            "assfukka",
            "imbécil",
            "idiotas",
            "culo completo",
            "a dólares",
            "a)",
            "b!tch",
            "b00bs",
            "b17ch",
            "b1tch",
            "bolsa de bolas",
            "bolas",
            "bastardo",
            "bestia",
            "bellend",
            "bestial",
            "bestialidad",
            "bi+ch",
            "biatch",
            "perra",
            "puta",
            "putas",
            "perras",
            "¡maldita sea",
            "blow job",
            "mamada",
            "mamadas",
            "boiolas",
            "bollock",
            "bollok",
            "hueso",
            "tetas",
            "booobs",
            "boooobs",
            "booooobs",
            "booooooobs",
            "senos",
            "buceta",
            "negro",
            "mierda",
            "bum",
            "butt",
            "buttmuch",
            "buttplug",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "cawk",
            "chink",
            "cipa",
            "cl1t",
            "entendido",
            "clítoris",
            "clits",
            "cnut",
            "polla",
            "polla-sucker",
            "masturbación",
            "pene",
            "gallos",
            "pollas",
            "polla grande",
            "pollasucked",
            "chupavergas",
            "chupa pollas",
            "penes negros grandes",
            "cocksuka",
            "cocksukka",
            "cok",
            "cokmuncher",
            "coksucka",
            "coon",
            "cox",
            "cum",
            "cummer",
            "colibrí",
            "semen",
            "corrida",
            "cunilingus",
            "cunillingus",
            "cunnilingus",
            "cuñada",
            "cuntlick",
            "cuntlicker",
            "cuntlicking",
            "cuñas",
            "cyalis",
            "cyberfuc",
            "ciberpolvo",
            "cibernético",
            "¡mierda",
            "los ciberdelincuentes",
            "ciberdelincuente",
            "d1ck",
            "maldita sea",
            "dildo",
            "consoladores",
            "dink",
            "dinks",
            "dirsa",
            "♪",
            "perro mierda",
            "perro",
            "donkeyribber",
            "doosh",
            "duche",
            "dyke",
            "eyaculado",
            "eyaculada",
            "eyaculados",
            "eyaculando",
            "eyaculaciones",
            "eyaculación",
            "eyakulate",
            "f u c k",
            "f u c k e r",
            "f4nny",
            "maricón",
            "maricas",
            "faggit",
            "faggs",
            "fanny",
            "fannyflaps",
            "fannyfucker",
            "fanyy",
            "grasa",
            "fcuk",
            "fcuker",
            "fcuting",
            "feck",
            "fecker",
            "felching",
            "caído",
            "♪♪",
            "dedo",
            "¡dedo",
            "dedos de mierda",
            "dedo de mierda",
            "dedos",
            "fistfuck",
            "fistfucking",
            "fistfucker",
            "fistfuckers",
            "fistfuckings",
            "fistfucks",
            "brida",
            "fook",
            "fooker",
            "follada",
            "hijo de puta",
            "mierdas",
            "puta mierda",
            "mierda mierda mierda madre mierda mierda mierda",
            "maldición",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fuker",
            "fukker",
            "fukkin",
            "fusibles",
            "fukwhit",
            "fukwit",
            "fux",
            "fux0r",
            "gangbang",
            "gangbanged",
            "gangbangs",
            "gaylord",
            "gaysex",
            "cabra",
            "maldito",
            "hardcoresex",
            "headass",
            "hoar",
            "hoare",
            "hoer",
            "hoes",
            "homo",
            "hore",
            "más caliente",
            "caliente",
            "hotsex",
            "jack-off",
            "jackoff",
            "jap",
            "jism",
            "jiz",
            "jizm",
            "jizz",
            "kawk",
            "kno",
            "knobed",
            "knobend",
            "knobhead",
            "knobjocky",
            "knobjokey",
            "kock",
            "kondum",
            "kondums",
            "kum",
            "kummer",
            "kumming",
            "kums",
            "kunilingus",
            "l3i+ch",
            "l3itch",
            "labia",
            "lujuria",
            "m0f0",
            "m0fo",
            "m45terbate",
            "ma5terb8",
            "ma5terbate",
            "masoquista",
            "master-bate",
            "masterb8",
            "masterbat*",
            "masterbat3",
            "masterbate",
            "masterbation",
            "masterbations",
            "mo-fo",
            "mof0",
            "mofo",
            "mothafuck",
            "mothafucka",
            "mothafuckas",
            "mothafuckaz",
            "mothafucking",
            "mothafucker",
            "bigotes",
            "mothafuckin",
            "mothafucks",
            "hijos de puta",
            "madre mierda",
            "muff",
            "muthafecker",
            "muthafuckker",
            "mutherfucker",
            "n1gga",
            "n1gger",
            "nazi",
            "nigg3r",
            "nigg4h",
            "niggah",
            "niggas",
            "niggaz",
            "negros",
            "nob",
            "nob jokey",
            "nobhead",
            "nobjocky",
            "nobjokey",
            "nueces",
            "orgasim",
            "orgasims",
            "orgasmo",
            "orgasmos",
            "p0rn",
            "peón",
            "pecker",
            "chupa penes",
            "teléfonosex",
            "phuk",
            "phuked",
            "phuking",
            "phukked",
            "phukking",
            "phuks",
            "phuq",
            "cabrón",
            "chulos",
            "orinar",
            "enojada",
            "meandos",
            "meadas",
            "pispa",
            "orina",
            "meando",
            "poop",
            "porno",
            "pornografía",
            "pornos",
            "pron",
            "pube",
            "pusse",
            "pussi",
            "pussies",
            "vagina",
            "vaginas",
            "recto",
            "retardado",
            "rimjaw",
            "rimming",
            "s hit",
            "s.o.b.",
            "sadista",
            "schlong",
            "tornillo",
            "scroat",
            "scrote",
            "escroto",
            "sexo",
            "sh!+",
            "sh",
            "sh1t",
            "shag",
            "shagger",
            "shaggin",
            "temblando",
            "transexual",
            "shi+",
            "skank",
            "smegma",
            "smut",
            "snatch",
            "spac",
            "sunk",
            "t1t1e5",
            "t1tties",
            "teets",
            "teez",
            "testículo",
            "titular",
            "titfuck",
            "tit",
            "tittie5",
            "tittie",
            "tittyfuck",
            "tittywank",
            "titwank",
            "tosser",
            "turd",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "twunt",
            "twunter",
            "v14gra",
            "v1gra",
            "viagra",
            "vulva",
            "w00se",
            "wang",
            "wank",
            "wanker",
            "wanky",
            "whoar",
            "willies",
            "willy",
        ],
    ],
    [
        "fr",
        [
            "4r5e",
            "5h1t",
            "5 heures",
            "a55",
            "anal",
            "anus",
            "ar5e",
            "arrs",
            "cul",
            "ânes",
            "enculé de cul",
            "culs",
            "enfoiré",
            "assfukka",
            "trou du cul",
            "gros cul",
            "a$",
            "en dollars",
            "c'est ça",
            "b00bs",
            "b17ch",
            "b1tch",
            "sac à bille",
            "boules",
            "sac à billes",
            "bâtard",
            "bête",
            "bêteté",
            "clocher",
            "bestial",
            "bestialité",
            "bi+ch",
            "biatch",
            "salope",
            "les salopes",
            "salopes",
            "sanglant",
            "blow job",
            "pipe",
            "pipes",
            "boiolas",
            "cliquetis",
            "bollok",
            "osseux",
            "sein",
            "seins",
            "bouchons",
            "les nichons",
            "boucliers",
            "booooooobs",
            "poitrines",
            "buceta",
            "enculé",
            "des conneries",
            "bum",
            "fesses",
            "mégots",
            "gros plan",
            "plug anal",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "cawk",
            "chine",
            "cipa",
            "cl1t",
            "clito",
            "clitoris",
            "clits",
            "nut",
            "coq",
            "suceur de bite",
            "visage de coq",
            "tête de coq",
            "munche de coq",
            "coq-muncher",
            "coqs",
            "sucre de bite",
            "bites sucées",
            "coqsucks",
            "cocksuka",
            "cocksukka",
            "cok",
            "cokmuncher",
            "coksucka",
            "coon",
            "cox",
            "sperme",
            "pomme",
            "cumming",
            "spermes",
            "éjaculation",
            "cunilingus",
            "cunillingus",
            "cunnilingus",
            "pâte",
            "lèche-cul",
            "chattes",
            "cyalis",
            "cyberfuc",
            "cyberfuck",
            "cyberfucked",
            "les cyber-fuckers",
            "cyberdépannage",
            "d1ck",
            "putain",
            "bite",
            "tête de bite",
            "gode",
            "godes",
            "évier",
            "éviers",
            "dirsa",
            "dlck",
            "enculé de chien",
            "chienne",
            "levrette",
            "d'ânes",
            "doux",
            "duché",
            "dyke",
            "éjaculations",
            "éjaculate",
            "f u c k",
            "f u c k e r",
            "pour",
            "pédé",
            "signalisation",
            "foggitt",
            "peaux",
            "fagot",
            "fagots",
            "pédés",
            "fanny",
            "les fannyflaps",
            "fany",
            "gras",
            "fcuk",
            "fcuker",
            "fcuking",
            "feu",
            "fecker",
            "feuillage",
            "infesté",
            "taux de chute",
            "culotte",
            "avec les doigts",
            "enfoirés",
            "fucking des doigts",
            "bouchées de doigts",
            "fuck",
            "farcis",
            "frappe de poing",
            "frappes de poing",
            "fusils",
            "bride",
            "fook",
            "fooker",
            "merde",
            "baisée",
            "enculés",
            "espèce d'enfoiré",
            "crétins",
            "putains",
            "fils de pute",
            "baise-moi",
            "connard",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fuker",
            "fukker",
            "fukkin",
            "fuks",
            "fukwhit",
            "fukwit",
            "fux",
            "fox0r",
            "un gangbang",
            "bandes",
            "des gangs",
            "gaylord",
            "gaysexe",
            "caprins",
            "seigneur",
            "dieu maudit",
            "nom de dieu",
            "hardcoresexe",
            "tête de cul",
            "arnaque",
            "hoare",
            "attaque",
            "sabots",
            "homo",
            "thorax",
            "les plus excités",
            "excité",
            "sexe chaud",
            "décollage",
            "jap",
            "branleur",
            "le jisme",
            "jiz",
            "jizm",
            "jizz",
            "kawk",
            "boutons",
            "boutonné",
            "bouton",
            "tête de bouton",
            "jocky",
            "boutonjokey",
            "kock",
            "kondum",
            "kondums",
            "kum",
            "kummer",
            "le kumming",
            "des kums",
            "kunilingus",
            "l3i+ch",
            "3 points",
            "labia",
            "luxure",
            "lustre",
            "m0f0",
            "m0fo",
            "m45terbate",
            "m5terb8",
            "ma5terbate",
            "masochiste",
            "maître-bateau",
            "maîtreb8",
            "maître-bat*",
            "maîtrise3",
            "maître",
            "masterbation",
            "masterbations",
            "masturbe",
            "les",
            "mof0",
            "mofo",
            "mothafuck",
            "mothafucka",
            "mothafuckas",
            "mothafuckaz",
            "mothafucked",
            "mothafucker",
            "mothafucks",
            "mothafuckin",
            "mothafucking",
            "mothafuckings",
            "merdeux",
            "muff",
            "le muthafecker",
            "muthafuckker",
            "n1gga",
            "n1gger",
            "nazi",
            "4 h",
            "negga",
            "niggué",
            "niggas",
            "niggaz",
            "nègre",
            "nègres",
            "nob",
            "nob jokey",
            "tête de noeud",
            "nobjocky",
            "nobjokey",
            "engourdissements",
            "sac à noix",
            "orgasim",
            "orgasims",
            "orgasme",
            "orgasmes",
            "p0rn",
            "sur gage",
            "pic",
            "pénis",
            "suceur de pénis",
            "téléphonex",
            "purée",
            "phuk",
            "ouvrés",
            "le phuking",
            "phukked",
            "ouvrage",
            "les phuks",
            "phuq",
            "maquereau",
            "pisse",
            "en colère",
            "pisser",
            "les pisseurs",
            "pousses de pisse",
            "caca",
            "porno",
            "pornographie mettant en scène des enfants",
            "pornos",
            "pique",
            "les briques",
            "tablier",
            "pube",
            "pusse",
            "pousse",
            "chatte",
            "rectum",
            "retard",
            "rimjaw",
            "jante",
            "s hit",
            "s.o.b.",
            "sadique",
            "schlong",
            "vissage",
            "scroat",
            "scrotte",
            "scrotum",
            "sexe",
            "sh!+",
            "- oui",
            "s'il vous plaît",
            "shagger",
            "shaggin",
            "sciages",
            "transexuelle",
            "shi+",
            "merdique",
            "crétin",
            "des merdes",
            "sankk",
            "smegma",
            "smut",
            "snatch",
            "spac",
            "croûte",
            "t1tt1e5",
            "t1tiétés",
            "tétons",
            "et toi",
            "testique",
            "testicule",
            "tit",
            "titfuck",
            "titre",
            "titre5",
            "tittyfuck",
            "tittywank",
            "titwank",
            "lancer",
            "tuyau",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "twunt",
            "détecteur",
            "v14gra",
            "v1gra",
            "vagin",
            "viagra",
            "vulve",
            "w00se",
            "wang",
            "gland",
            "branlé",
            "souris",
            "pute",
            "walies",
            "willy",
        ],
    ],
    [
        "it",
        [
            "allupato",
            "ammucchiata",
            "anale",
            "arrapato",
            "arrusa",
            "arruso",
            "assatanato",
            "bagascia",
            "bagassa",
            "bagnarsi",
            "baldracca",
            "balle",
            "battere",
            "battona",
            "belino",
            "biga",
            "bocchinara",
            "bocchino",
            "bofilo",
            "boiata",
            "bordello",
            "brinca",
            "bucaiolo",
            "budiùlo",
            "busone",
            "cacca",
            "caciocappella",
            "cadavere",
            "cagare",
            "cagata",
            "cagna",
            "casci",
            "cazzata",
            "cazzimma",
            "cazzo",
            "cesso",
            "cazzone",
            "checca",
            "chiappa",
            "chiavare",
            "chiavata",
            "ciospo",
            "ciucciami il cazzo",
            "coglione",
            "coglioni",
            "cornuto",
            "cozza",
            "culattina",
            "culattone",
            "culo",
            "ditalino",
            "fava",
            "femminuccia",
            "fica",
            "figa",
            "figlio di buona donna",
            "figlio di puttana",
            "figone",
            "finocchio",
            "fottere",
            "fottersi",
            "fracicone",
            "fregna",
            "frocio",
            "froscio",
            "goldone",
            "guardone",
            "imbecille",
            "incazzarsi",
            "incoglionirsi",
            "ingoio",
            "leccaculo",
            "lecchino",
            "lofare",
            "loffa",
            "loffare",
            "mannaggia",
            "merda",
            "merdata",
            "merdoso",
            "mignotta",
            "minchia",
            "minchione",
            "mona",
            "monta",
            "montare",
            "mussa",
            "nave scuola",
            "nerchia",
            "padulo",
            "palle",
            "palloso",
            "patacca",
            "patonza",
            "pecorina",
            "pesce",
            "picio",
            "pincare",
            "pippa",
            "pinnolone",
            "pipì",
            "pippone",
            "pirla",
            "pisciare",
            "piscio",
            "pisello",
            "pistolotto",
            "pomiciare",
            "pompa",
            "pompino",
            "porca",
            "porca madonna",
            "porca miseria",
            "porca puttana",
            "porco",
            "porco due",
            "porco zio",
            "potta",
            "puppami",
            "puttana",
            "quaglia",
            "recchione",
            "regina",
            "rincoglionire",
            "rizzarsi",
            "rompiballe",
            "rompipalle",
            "ruffiano",
            "sbattere",
            "sbattersi",
            "sborra",
            "sborrata",
            "sborrone",
            "sbrodolata",
            "scopare",
            "scopata",
            "scorreggiare",
            "sega",
            "slinguare",
            "slinguata",
            "smandrappata",
            "soccia",
            "socmel",
            "sorca",
            "spagnola",
            "spompinare",
            "sticchio",
            "stronza",
            "stronzata",
            "stronzo",
            "succhiami",
            "succhione",
            "sveltina",
            "sverginare",
            "tarzanello",
            "terrone",
            "testa di cazzo",
            "tette",
            "tirare",
            "topa",
            "troia",
            "trombare",
            "vacca",
            "vaffanculo",
            "vangare",
            "zinne",
            "zio cantante",
            "zoccola",
        ],
    ],
    [
        "hi",
        [
            "4r5e",
            "5h1t",
            "5hit",
            "a55",
            "गुदामैथुन",
            "एनस",
            "ar5e",
            "arrse",
            "आर्सेना",
            "शस्त्र",
            "ass",
            "ass-fucker",
            "assfucker",
            "assfukka",
            "asshole",
            "assholes",
            "asswhole",
            "$$",
            "$",
            "b",
            "b00b",
            "b17ch",
            "b1tch",
            "बॉलबैग",
            "गेंद",
            "गेंदों",
            "बस्टर्ड",
            "जानवर",
            "समानता",
            "घंटी",
            "श्रेष्ठ",
            "श्रेष्ठता",
            "bi+ch",
            "बिच",
            "बिटच",
            "चूंचियां",
            "बिटचर",
            "बिट्च",
            "बिटचिन",
            "बिटिंग",
            "खूनी",
            "blow job",
            "blowjob",
            "बियोला",
            "बोल्क",
            "बोललोक",
            "हड्डी",
            "शराब",
            "स्तन",
            "booooobs",
            "buceta",
            "बगीचा",
            "हिन्दी",
            "bum",
            "बट",
            "बटहोल",
            "बटमच",
            "buttplug",
            "c0ck",
            "c0cksucker",
            "carpet muncher",
            "चिंक",
            "cipa",
            "cl1t",
            "क्लिट",
            "क्लिटोरिस",
            "अखरोट",
            "मुर्गा",
            "मुर्गा चूसने वाला",
            "कॉकफेस",
            "कॉक",
            "मुर्गा चूसने",
            "कोक",
            "cokmuncher",
            "coksucka",
            "कोन",
            "केकड़ा",
            "सह",
            "cummer",
            "cumming",
            "कमशॉट",
            "गुलगुला",
            "cunillingus",
            "हिंदी",
            "चाचा",
            "cuntlick",
            "cuntlicker",
            "cuntlicking",
            "cunts",
            "cyalis",
            "साइबरफ़ुक",
            "साइबर बकवास",
            "d1ck",
            "damn",
            "डिक",
            "dickhead",
            "डिल्डो",
            "dildos",
            "गुत्थी",
            "डंक",
            "कुत्ते-fucker",
            "कुत्ते",
            "dogging",
            "गधा",
            "डोष",
            "डच",
            "डाइक",
            "ejaculate",
            "ejaculated",
            "ejaculation",
            "ejaculations",
            "ejakulate",
            "f u c k",
            "f u c k e r",
            "f4nny",
            "फ़ैग",
            "छूत",
            "चुभोना",
            "fagot",
            "फैनी",
            "फैनीफ्लैप",
            "कट्टर",
            "वसा",
            "fcuk",
            "fcuker",
            "fcuking",
            "fecker",
            "गिरना",
            "गिरती",
            "उंगली करना",
            "fingerfucked",
            "उंगलियों",
            "मुट्ठीकरना",
            "fistfucked",
            "fistfucker",
            "fistfuckers",
            "fistfucking",
            "fistfuck",
            "फुहार",
            "चॉकर",
            "भाड़ में जाओ",
            "बकवास",
            "गड़बड़",
            "मुख-मैथुन",
            "fuckheads",
            "कमबख्त",
            "fuckingshitmotherfucker",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fucker",
            "fukkin",
            "फक",
            "फूहड़",
            "fux0r",
            "गिरोह बैंग",
            "gangbanged",
            "समलैंगिक",
            "बकरी",
            "देवता",
            "देवी",
            "कट्टरसेक्स",
            "सिर",
            "होर",
            "हो",
            "होम",
            "सींग का",
            "सेक्सी",
            "जैक ऑफ",
            "जैकपॉट",
            "जैप",
            "मरोड़ते",
            "jism",
            "जिज़",
            "जिज़्म",
            "कावा",
            "घुंडी",
            "knobjocky",
            "kock",
            "कोंडोम",
            "कोन्डम",
            "कुम्भ",
            "kumming",
            "गुनगुना",
            "l3i+ch",
            "l3itch",
            "लैबिया",
            "चमकना",
            "m0f0",
            "m0fo",
            "m45terbate",
            "ma5terb8",
            "ma5terbate",
            "मैसोचिस्ट",
            "मास्टर-बेट",
            "मास्टरब8",
            "मास्टरबैट*",
            "मास्टरबैट3",
            "मास्टरबेट",
            "masterbation",
            "हस्तमैथुन",
            "mo-fo",
            "mof0",
            "साइटमैप",
            "mothafucka",
            "mothafuckaz",
            "mothafucked",
            "mothafucker",
            "mothafuckin",
            "mothafucking",
            "माँ",
            "motherfucked",
            "motherfucker",
            "motherfuckers",
            "motherfuckin",
            "motherfucking",
            "motherfuckka",
            "माताओं",
            "माफ",
            "muthafecker",
            "muthafuckker",
            "mutherfucker",
            "n1gga",
            "n1gger",
            "नाज़ी",
            "nigg3r",
            "nigg4h",
            "निगा",
            "निगाह",
            "नागा",
            "nigger",
            "niggers",
            "नोब",
            "nob jokey",
            "नोबहेड",
            "nobjocky",
            "nobjokey",
            "नट्सैक",
            "orgasim",
            "संभोग सुख",
            "p0",
            "मोहन",
            "पेकर",
            "पेनिस",
            "penisfucker",
            "फोनसेक्स",
            "चक",
            "फुक",
            "फुकेत",
            "phuq",
            "pigfucker",
            "पिम्पिस",
            "पेशाब",
            "pissed",
            "pissing",
            "पेशाब करना",
            "पोप",
            "अश्लील",
            "पोर्नोग्राफी",
            "ट्रिक",
            "pricks",
            "प्रोन",
            "पुसी",
            "बिल्ली",
            "राशि",
            "मंदिर",
            "रिमजॉ",
            "rimming",
            "s hit",
            "s.o.b.",
            "sadist",
            "schlong",
            "पेंच",
            "झरना",
            "घूंघट",
            "अंडकोष",
            "वीर्य",
            "सेक्स",
            "sh!+",
            "sh!t",
            "sh1t",
            "shag",
            "shagger",
            "shaggin",
            "shagging",
            "shemale",
            "शि +",
            "shitfuck",
            "shitful",
            "शिटिंग",
            "पतला",
            "शिथिल",
            "शिटर",
            "शिट्टी",
            "skank",
            "गुदगुदी",
            "smegma",
            "smut",
            "छीनना",
            "बेटा",
            "स्पेक",
            "टट्टू",
            "t1t1e5",
            "टी1टी",
            "टी",
            "टीज़",
            "वृषण",
            "तैसा",
            "टिट्स",
            "टिट",
            "tittie5",
            "tittiefucker",
            "titties",
            "tittyfuck",
            "tittywank",
            "titwank",
            "toser",
            "turd",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "ट्वंट",
            "ट्वंटर",
            "v14gra",
            "v1gra",
            "योनि",
            "वियाग्रा",
            "vulva",
            "w00se",
            "वांग",
            "wank",
            "wanker",
            "wanky",
            "whoar",
            "whore",
            "इच्छा",
        ],
    ],
    [
        "ja",
        [
            "4r5eの",
            "5h1t",
            "5ヒット",
            "の55",
            "アナル",
            "ログイン",
            "ar5eの",
            "アルス",
            "トピックス",
            "ass fucker",
            "アコース",
            "assfucker",
            "アスフッカ",
            "アスホール",
            "$$$$",
            "アスドル",
            "a$s",
            "b!パッチ",
            "b00bsの",
            "b17chの",
            "b1tchの",
            "ボールバッグ",
            "ボールボール",
            "ボールバック",
            "バスタード",
            "ビーストリアル",
            "獣性",
            "ベルン",
            "ベスト",
            "人気カテゴリー",
            "bi+chの",
            "バイアッチ",
            "ビットチェボーイ",
            "ビットチャー",
            "ビットチャーズ",
            "ビットチェス",
            "ビットキャッシュ",
            "blow job",
            "ブロージョブ",
            "ボヨラス",
            "ボルロック",
            "ボロク",
            "ボブ",
            "ブーブ",
            "ブーブス",
            "ブーツ",
            "ブームーブ",
            "ブームーブス",
            "ブラストス",
            "ボセタ",
            "バッガー",
            "ブルシット",
            "バム",
            "バッツ",
            "バトール",
            "バッチュ",
            "パスワード",
            "c0cksuckerの",
            "carpet muncher",
            "チンク",
            "プリカ",
            "クラス1t",
            "クライストリ",
            "クルミ",
            "コック",
            "コックサッカー",
            "コックフェイス",
            "コックヘッド",
            "コックムンチャー",
            "コックサック",
            "コック吸う",
            "コックキャッキング",
            "コックスカ",
            "コックスッカ",
            "コクンチャー",
            "コクサッカ",
            "コックス",
            "クムマー",
            "つぶやき",
            "カムス",
            "cuntlicking",
            "シアリス",
            "サイバーフック",
            "サイバーfuck",
            "サイバーfucked",
            "サイバーファッカー",
            "サイバーファッキング",
            "d1ckの",
            "ダムン",
            "dickheadの",
            "ディルドー",
            "ディルドス",
            "ダイニング",
            "ディルサ",
            "ダック",
            "犬 fucker",
            "ドッグギン",
            "ドッギング",
            "ドオッシュ",
            "デュチェ",
            "ダイケ",
            "エジャキュレート",
            "ejaculated(エジャキュレーション)",
            "電子メール",
            "ejaculating(エジャカルト)",
            "ejaculating(エジャキュレーション)",
            "ejakulateの",
            "f u c k",
            "f u c k e r",
            "おばあさん",
            "ファグ",
            "ファッギング",
            "ファゴット",
            "ファグス",
            "ファンニー",
            "ファンニーフラップ",
            "ファンニーfucker",
            "脂肪マッサージ",
            "フォーク",
            "フィードバック",
            "フェッカー",
            "落ち着き",
            "フィンガーfuck",
            "指fucked",
            "フィンガーファイヤー",
            "フィンガーファッカー",
            "指fucking",
            "フィンガーfucks",
            "フィストfuck",
            "fistfucked",
            "fistfucker",
            "フィストfuckers",
            "fistfucking",
            "fistfuckings",
            "fistfucks",
            "フランジ",
            "フーカー",
            "クソ",
            "フラッシャー",
            "クソヘッド",
            "fuckingshitmotherfucker",
            "fuckwhitさん",
            "fuckwitの",
            "fudge packer",
            "ファッジパック",
            "フューカー",
            "フクカー",
            "フクキン",
            "ファクシミリ",
            "fukwitの",
            "ギャングバン",
            "ギャング",
            "ギャングバング",
            "ガールフレンド",
            "ゲイsexsex",
            "ヤギ",
            "ゴッドダム",
            "神秘的な被害を受けた",
            "ゴダメン",
            "ハードコアsexsex",
            "ヘッドサス",
            "ふりがな",
            "ホーンシーズ",
            "ホーンシー",
            "ホットsex",
            "ジャックオフ",
            "ジャークオフ",
            "ジャーミー",
            "カウク",
            "ノビーズ",
            "ノベット",
            "ノベンド",
            "ノブヘッド",
            "ノブジョキー",
            "コンドム",
            "コンダム",
            "クマー",
            "クムス",
            "l3i+chの",
            "l3itchの",
            "ラボリア",
            "プロフィール",
            "m0f0",
            "m0foの",
            "m45terbateの",
            "マ5terb8",
            "ma5terbateの",
            "マゾキスト",
            "マスター・リベート",
            "マスターb8",
            "マスターバット*",
            "マスターバット3",
            "マスターリベート",
            "マスタービング",
            "マスターブレーション",
            "masturbate",
            "モフォ",
            "モフ0",
            "mothafuck",
            "モタクソファ",
            "mothafuckas",
            "mothafuckaz",
            "mothafucked",
            "mothafucker",
            "モタクソファー",
            "mothafuckin",
            "mothafucking",
            "mothafuckings",
            "mothafucks",
            "母fuck",
            "母fucked",
            "母fucker",
            "母fuckers",
            "母fuckin",
            "母fucking",
            "母fuckings",
            "母fuckka",
            "母fucks",
            "マフ",
            "n1ggaの",
            "n1ガー",
            "ナジ",
            "ニグ3r",
            "ニグ4h",
            "ニグガ",
            "ナイガス",
            "ニガー",
            "ノブ",
            "nob jokey",
            "ノブジョーキー",
            "ナムナッツ",
            "ナッツマック",
            "オーガスム",
            "オルガスム",
            "p0rnの",
            "プーン",
            "ペッカー",
            "ペニス",
            "penisfucker",
            "電話sex",
            "ファック",
            "フクウク",
            "フィッシング",
            "ピッキング",
            "プーク",
            "ピクチャー",
            "ピンピス",
            "小便",
            "放尿",
            "小便小便",
            "pissflaps",
            "プッシー",
            "ポップ",
            "恋物癖",
            "パトリック",
            "プロン",
            "パブ",
            "パッシー",
            "パスシス",
            "リクルート",
            "リタード",
            "リムジャウ",
            "リミング",
            "s hit",
            "s.o.b.",
            "サディスト",
            "シュロン",
            "スクリュー",
            "セメン",
            "性別",
            "お問い合わせ",
            "ツイート",
            "sh1tの",
            "シェーグ",
            "シャガール",
            "シャギン",
            "シェーディング",
            "シーメール",
            "シープラス",
            "サイトマップ",
            "インタビュー",
            "シッター",
            "インフォメーション",
            "スカンク",
            "ソリューション",
            "スメグマ",
            "スムート",
            "スナッチ",
            "息子-of-a-bitch",
            "スパク",
            "t1tt1e5の特長",
            "t1タイ",
            "テッツ",
            "テエズ",
            "リファレンス",
            "アクティシクル",
            "タイ5",
            "tittiefucker",
            "ティワンク",
            "titwankの",
            "トッサー",
            "タード",
            "tw4tの",
            "タワトヘッド",
            "トワット",
            "トウランター",
            "v14graの",
            "v1graの",
            "バギーナ",
            "ビアグラ",
            "w00se",
            "ワンク",
            "ワンカー",
            "ワンキー",
            "スタッフ",
            "パーティー",
            "メニュー",
        ],
    ],
    [
        "ko",
        [
            "4r5e를",
            "1시간",
            "5열",
            "a55's 수",
            "뚱 베어",
            "한국어",
            "사이트맵",
            "카테고리",
            "장바구니",
            "₢ 킹",
            "회사 소개",
            "제품 정보",
            "볼랙",
            "배틀그라운드",
            "제품정보",
            "채용 정보",
            "인기있는",
            "blow job",
            "채용정보",
            "스낵 바",
            "뼈",
            "carpet muncher",
            "프로젝트",
            "바퀴 슈커",
            "큰 가슴",
            "채용공고",
            "인기 카테고리",
            "cyalis의",
            "사이버후크",
            "사이버감사",
            "사이버fucker",
            "사이버fuckers",
            "이름 *",
            "언어: 한국어",
            "개 게이",
            "개진",
            "관련 기사",
            "f u c k",
            "f u c k e r",
            "팟캐스트",
            "모든 새",
            "뚱뚱뚱",
            "· fcuk",
            "털이 많은",
            "주먹질",
            "중년부인",
            "옵션 정보",
            "빌어 먹을hitmotherfucker",
            "fudge packer",
            "펌웨어",
            "갱뱅",
            "게이주",
            "게이sex",
            "신담",
            "뉴스 레터",
            "신담n",
            "하드코어sex",
            "맨 위로",
            "가장 핫한",
            "핫 성별",
            "잭 오프",
            "잭오프",
            "주 메뉴",
            "칼 머리",
            "칼조키",
            "엄마5terb8",
            "마스터베이트",
            "마스터b8",
            "마스터 배트*",
            "마스터배트3",
            "모thafuck",
            "모thafucka",
            "모thafuckas",
            "모thafuckaz",
            "모thafucked",
            "모thafucker",
            "모thafuckers",
            "모thafuckin",
            "모thafucking",
            "모thafucks",
            "엄마",
            "엄마fuckka",
            "모든 인기있는",
            "노브",
            "nob jokey",
            "노브조키",
            "메뉴 닫기",
            "견과류",
            "오르가즘",
            "페커",
            "페니스",
            "오줌싸기",
            "pussys 소개",
            "핥기",
            "s hit",
            "사이트맵.",
            "관련 제품",
            "쉬메일",
            "·",
            "전체장편",
            "스카크",
            "스크랩",
            "아들의 a-bitch",
            "스펀지",
            "t1티",
            "시험대",
            "가슴5",
            "tittiefucker의",
            "tittyfuck의",
            "tittywank, 영국",
            "titwank의",
            "v14그라",
            "v1그라",
            "뱅커",
        ],
    ],
    [
        "pt",
        [
            "4r5e",
            "5h1t",
            "5",
            "a55",
            "anal",
            "anus",
            "ar5e",
            "arrumos",
            "arse",
            "arses",
            "bunda",
            "filho da puta",
            "julgo",
            "o quê",
            "idiota",
            "idiotas",
            "- o quê",
            "$$",
            "como $",
            "a $s",
            "b!tch",
            "b00",
            "b17ch",
            "b1",
            "saco de bola",
            "bolas",
            "sacana",
            "bestial",
            "bestialidade",
            "amigos",
            "bi-ch",
            "biatch",
            "cabrão",
            "putas",
            "cadelas",
            "sangrento",
            "blow job",
            "broche",
            "broches",
            "boa sorte",
            "bolo",
            "osso",
            "mamas",
            "peitos",
            "buceta",
            "bugger",
            "merda",
            "bum",
            "mas..",
            "bundas",
            "mastplug",
            "c0m",
            "c0cksucker",
            "carpet muncher",
            "cawk",
            "chink",
            "cipa",
            "não",
            "claire",
            "clitoris",
            "clérigos",
            "amendoim",
            "caralho",
            "cara de pau",
            "cabeça de pau",
            "galão",
            "carpinteiro",
            "paus",
            "pausucked",
            "pausucking",
            "pausuka",
            "cok",
            "colheitadeira",
            "o que é que se passa",
            "cláudia",
            "cox",
            "porra",
            "de verão",
            "cumming",
            "cums",
            "com licença",
            "cunilingus",
            "cunillingus",
            "cúpula",
            "não sei",
            "o que é isso",
            "incômodo",
            "cúmplices",
            "cialis",
            "cyberfuc",
            "cyberfuck",
            "cyberfucked",
            "cibercriminoso",
            "os cibercriminosos",
            "cyberfucking",
            "maldição",
            "pauzinho",
            "dildo",
            "dildos",
            "dink",
            "dinks",
            "dirsança",
            "dl",
            "cãozinho",
            "- não",
            "duquesa",
            "dyke",
            "ejaculações",
            "ejaculada",
            "ejaculando",
            "ejaculação",
            "ejaculação interna",
            "f u c k",
            "f u c k e r",
            "f4b",
            "fagão",
            "fagging",
            "faggit",
            "faggs",
            "fagot",
            "fagots",
            "fags",
            "fantoche",
            "fannyflaps",
            "fany",
            "gorda",
            "fcuk",
            "fcuker",
            "fcuking",
            "pateta",
            "fecker",
            "felching",
            "caído",
            "fodido",
            "filhos da puta",
            "fistfucked",
            "fistfucker",
            "fistfuckers",
            "fistfucking",
            "fistfuckings",
            "foda-se",
            "flange",
            "fook",
            "fooker",
            "fodida",
            "cabrões",
            "caralhos",
            "fodas",
            "fudge packer",
            "fudgepacker",
            "fuk",
            "fuker",
            "fukker",
            "cortina",
            "fuks",
            "eu sei",
            "fux",
            "gangbang",
            "gangbanged",
            "jogos de vestir",
            "gay",
            "gaysex",
            "cabras",
            "raios",
            "maldito",
            "hardcoresex",
            "headass",
            "hoar",
            "hoare",
            "hoer",
            "hoes",
            "homo",
            "hore",
            "excitado",
            "sexo quente",
            "jack-off",
            "jackoff",
            "tudo bem",
            "jismo",
            "júnior",
            "jizm",
            "jizz",
            "kawk",
            "botão",
            "cabeça de cabeça",
            "- sim",
            "kum",
            "kummer",
            "kums",
            "i3i+ch",
            "i3",
            "laboratório",
            "brilho",
            "lustrando",
            "m0f0",
            "m0fo",
            "m45terbate",
            "o que fazer",
            "ma5terbate",
            "masoquista",
            "mestre-bate",
            "masterb8",
            "masterbat",
            "masterbat3",
            "masterbate",
            "masterbação",
            "masterbations",
            "masturbar-se",
            "mo-fo",
            "o que se passa",
            "mofo",
            "mothafuckers",
            "que se lixe",
            "fodendo",
            "mothafuckings",
            "merdas",
            "filho da mãe",
            "muthafecer",
            "fode-se",
            "n1gga",
            "nazi",
            "o que foi",
            "nigga",
            "os pretos",
            "o que é",
            "preto",
            "pretos",
            "no",
            "nob jokey",
            "nobjocky",
            "boa noite",
            "nozes",
            "orgasim",
            "orgasims",
            "orgasmo",
            "orgasmos",
            "p0rn",
            "pão",
            "pecker",
            "pênis",
            "pênisfucker",
            "telefonesex",
            "phuck",
            "phuk",
            "phuked",
            "a tremer",
            "phukked",
            "phukking",
            "phuras",
            "phuq",
            "pimpos",
            "miúda",
            "miúdo",
            "pissers",
            "pias",
            "pissflaps",
            "imposição",
            "mijando",
            "cocó",
            "pornô",
            "por favor",
            "pornografia",
            "pimba",
            "cricks",
            "pron",
            "bar",
            "puxa",
            "puxas",
            "cona",
            "conas",
            "recto",
            "retirada",
            "bordas",
            "s hit",
            "s.o.b.",
            "sádico",
            "schlong",
            "parafusos",
            "scroat",
            "scrote",
            "escroto",
            "sémen",
            "sexo",
            "mais",
            "shag",
            "shagger",
            "shaggin",
            "shagging",
            "shema",
            "brilhante",
            "skank",
            "puta",
            "smegma",
            "snatch",
            "spac",
            "t1t1e5",
            "t1t",
            "tetas",
            "testículo",
            "t",
            "não te metas",
            "titã",
            "titãs",
            "que merda",
            "turva",
            "tw4t",
            "twat",
            "twathead",
            "twatty",
            "twunt",
            "twunter",
            "v14g",
            "v1gra",
            "vagina",
            "via satélite",
            "vulva",
            "wang",
            "vamos",
            "wanker",
            "wanky",
            "willies",
            "willy",
        ],
    ],
    [
        "ru",
        [
            "4r5e",
            "5h1t",
            "5хит",
            "55",
            "анальный",
            "анус",
            "ar5e",
            "аррс",
            "задница",
            "задницы",
            "ублюдок",
            "асфукка",
            "придурок",
            "придурки",
            "полный",
            "$$",
            "как $",
            "$",
            "б/ч",
            "00бс",
            "17ч",
            "b1tch",
            "мешок с мячом",
            "шары",
            "мешок",
            "звериный",
            "звериность",
            "колокольчик",
            "скотство",
            "би+ч",
            "двустворчатый",
            "сука",
            "сукин сын",
            "шлюха",
            "шлюхи",
            "стервы",
            "стерва",
            "кровавый",
            "blow job",
            "минет",
            "буйвол",
            "боллок",
            "буллок",
            "костлявый",
            "сиська",
            "сиськи",
            "болваны",
            "грудь",
            "буцета",
            "говнюк",
            "дерьмо",
            "бродяга",
            "болван",
            "затвор",
            "вес",
            "мудак",
            "carpet muncher",
            "топор",
            "ерунда",
            "шипа",
            "cl1t",
            "клит",
            "клитор",
            "клиты",
            "кнут",
            "член",
            "петух",
            "лицо члена",
            "членоголовый",
            "членосос",
            "петухи",
            "хулиган",
            "сосать член",
            "членсука",
            "кокс",
            "кумунчер",
            "кексука",
            "кун",
            "кум",
            "колоть",
            "кумминг",
            "кумс",
            "кумшот",
            "кунилингус",
            "куниллингус",
            "куннилингус",
            "пизда",
            "щекотать",
            "щекотливый",
            "пиздец",
            "циалис",
            "киберфук",
            "кибер-трах",
            "киберпроклятый",
            "киберпреступник",
            "киберпреступники",
            "кибер-ебать",
            "1кк",
            "проклятый",
            "фаллоимитатор",
            "ворчать",
            "помойка",
            "дирша",
            "собачий",
            "собака",
            "оселовоз",
            "душ",
            "герцог",
            "дамба",
            "эякулировать",
            "эякулированный",
            "эякулирует",
            "эякулирующий",
            "эякуляция",
            "f u c k",
            "f u c k e r",
            "4nny",
            "педик",
            "педикюр",
            "педики",
            "фагот",
            "фаготы",
            "фанатичный",
            "фаннифлапс",
            "толстый",
            "фук",
            "засранец",
            "грязь",
            "хуй",
            "сволочь",
            "откидывание",
            "сорняк",
            "фелляция",
            "сраный пальцем",
            "ублюдки",
            "гребаный палец",
            "пальчики",
            "сраный",
            "долбаный",
            "фланцеобразный",
            "обман",
            "фукер",
            "ебать",
            "трахаться",
            "ебаный",
            "гребаный",
            "чертов ублюдок",
            "блядь",
            "fudge packer",
            "фуккин",
            "фуквист",
            "приправа",
            "fux0r",
            "бандаж",
            "бандитизм",
            "бандиты",
            "гей-лорд",
            "гейсекс",
            "козел",
            "черт возьми",
            "хардкорекс",
            "голова",
            "хриплый",
            "кабак",
            "горшок",
            "мотыга",
            "гомо",
            "обнимать",
            "самый роговой",
            "роговой",
            "секс",
            "отсрочка",
            "рывок",
            "яблочный",
            "джизм",
            "джиза",
            "бегство",
            "шипение",
            "лаять",
            "бездельник",
            "ручка",
            "тупица",
            "неряшливый",
            "кнопка",
            "стучать",
            "кондум",
            "кондумы",
            "куммер",
            "l3i+ch",
            "3ч",
            "лабиринт",
            "похоть",
            "m0f0",
            "m0fo",
            "m45terterate",
            "ma5terb8",
            "ма5тербат",
            "мазохист",
            "мастер-бит",
            "мастер8",
            "мастербат",
            "мастерить",
            "мастербирование",
            "мастербации",
            "мастурбировать",
            "мофо",
            "мафия",
            "фото",
            "молоток",
            "мотафук",
            "мотафак",
            "мотылек",
            "усатый",
            "мотафакер",
            "мотафакеры",
            "мотафакин",
            "молохвост",
            "кекс",
            "мутхафекер",
            "n1gga",
            "n1gger",
            "нацистский",
            "nigg3r",
            "nigg4h",
            "нигга",
            "ниггер",
            "ниггеры",
            "ниггаз",
            "негр",
            "ноб",
            "nob jokey",
            "нобджоки",
            "бежокей",
            "обезболивающие",
            "гайка",
            "оргазм",
            "рог",
            "пешка",
            "пенис",
            "пенисовец",
            "телефоны",
            "фак",
            "обожженный",
            "пыхтение",
            "пьяный",
            "пьянство",
            "паук",
            "сутенер",
            "моча",
            "разозленный",
            "порох",
            "поршни",
            "сосульки",
            "пессина",
            "отстой",
            "какашка",
            "порно",
            "порнография",
            "уколы",
            "наклон",
            "лоб",
            "гной",
            "пусси",
            "киска",
            "прямая кишка",
            "отсталый",
            "римжа",
            "обрамление",
            "s hit",
            "с.о.б.",
            "садист",
            "шлонг",
            "облажаться",
            "горло",
            "писать",
            "мошонка",
            "сперма",
            "ше! +",
            "блин",
            "шт",
            "дрожать",
            "шаггин",
            "женщина",
            "ши+",
            "дерьмовый",
            "говнюки",
            "смегма",
            "смута",
            "похищать",
            "пак",
            "отрыжка",
            "t1tt1e5",
            "т1тис",
            "трость",
            "тез",
            "тестовый",
            "яичко",
            "сиськи5",
            "чокнутый",
            "титванк",
            "тоссер",
            "tw4t",
            "v14гра",
            "v1гра",
            "влагалище",
            "виагра",
            "вульва",
            "00се",
            "ван",
            "дрочить",
            "вялый",
            "вор",
            "мухи",
            "волей",
        ],
    ],
    [
        "zh",
        [
            "4r5e (4r5e) (韩语)",
            "5小时1小时",
            "5发",
            "a55个",
            "肛门",
            "轨道5e",
            "皮肤",
            "屁股",
            "他妈的",
            "驴",
            "阿斯福卡语name",
            "混帐",
            "屁股整齐",
            "(单位:美元)",
            "作为美元",
            "ch",
            "页:1",
            "b17ch (英语)",
            "b1吨级",
            "球囊",
            "球头",
            "鸡巴",
            "杂种",
            "兽形",
            "兽性",
            "铃声",
            "最佳状态",
            "质量",
            "双倍径",
            "双节",
            "贱人",
            "婊子们",
            "骂人",
            "该死的",
            "blow job",
            "吹箫",
            "bo",
            "胡说",
            "波罗克",
            "骨头",
            "嘘声",
            "乳头",
            "嘘嘘",
            "布鲁塞塔",
            "可恶",
            "废话",
            "流浪汉",
            "臀部",
            "屁眼",
            "枪托",
            "c0ck (英语)",
            "carpet muncher",
            "aw",
            "中国",
            "齐巴",
            "cl1t 键",
            "阴蒂",
            "果实",
            "鸡巴脸",
            "鸡头",
            "鸡尾酒",
            "公鸡",
            "鸡鸡",
            "库克",
            "库克门彻",
            "库克萨",
            "铜",
            "缩写",
            "积分",
            "弯曲",
            "累积射击",
            "阴囊",
            "库尼灵格斯",
            "阴间",
            "贱货",
            "低调",
            "ya",
            "网络福克",
            "网络操",
            "网络他妈的",
            "网络混蛋",
            "d1ck (英语)",
            "蠢货",
            "迪尔多",
            "二极管",
            "叮当",
            "日数a",
            "烂透了",
            "狗娘养的",
            "狗语",
            "养狗",
            "驴肋架",
            "杜许",
            "杜彻",
            "堤坝",
            "射线",
            "射精术",
            "标记",
            "f u c k",
            "f u c k e r",
            "f4ny (英语)",
            "同性恋",
            "发牢骚",
            "粪便",
            "风扇",
            "扇形叶片",
            "你个混蛋",
            "迷恋",
            "肥猪",
            "fcuk (英语)",
            "鸡肉",
            "欢呼",
            "呕吐",
            "堕落",
            "口交时",
            "手指他妈的",
            "指头",
            "拳头操",
            "拳头他妈的",
            "拳头",
            "他妈的拳头",
            "花纹",
            "恶棍",
            "他妈的混蛋",
            "他妈的我",
            "妈的",
            "fudge packer",
            "软糖包装机",
            "乌克",
            "福尔克",
            "乌克金",
            "烟花",
            "乌克维特",
            "阴茎",
            "furx0r (英语)",
            "黑帮",
            "帮派",
            "同性恋者",
            "山羊队",
            "天杀的",
            "硬核性行为",
            "头部",
            "桨",
            "爱",
            "吼声",
            "鹅",
            "高尔",
            "角最强",
            "角质",
            "热性",
            "骗局",
            "贾宝玉",
            "jism 语句",
            "吉兹",
            "坐标",
            "键",
            "针叶",
            "已锁定",
            "旋钮",
            "旋钮头",
            "键盘",
            "鸡",
            "宽度",
            "库姆",
            "ku",
            "单位",
            "库林斯",
            "l3i+ch 键",
            "ưμ㼯a",
            "阴唇",
            "欲望",
            "淫荡",
            "m0f0 时",
            "m0fo 数据",
            "m45 位点",
            "ma5terb8 键",
            "半径",
            "虐恋狂",
            "主减法",
            "主机b8",
            "高级项目*",
            "高级bat3",
            "高级",
            "掌握",
            "手淫",
            "mo",
            "摩尔福",
            "调味料",
            "摩塔他妈的",
            "灭鼠机",
            "马夫",
            "变种人",
            "无",
            "n1gger (英语)",
            "纳粹",
            "零点3r",
            "ni4h",
            "黑鬼",
            "唉哟",
            "黑鬼们",
            "纳吉",
            "黑头",
            "nob jokey",
            "头",
            "无趣",
            "无名",
            "麻核",
            "疯子",
            "质子",
            "矫形",
            "高潮",
            "p0rn 语录",
            "啄木鸟",
            "电话",
            "发球",
            "福尔",
            "划开",
            "摇摆",
            "发声",
            "p",
            "猪头",
            "皮条客",
            "撒尿",
            "愤怒",
            "尿裤子",
            "撒尿器",
            "小便便便便便时",
            "细小的叶片",
            "神经病",
            "便便",
            "色情电影",
            "色情制品",
            "刺头",
            "专业",
            "普丝",
            "猫咪",
            "娘们",
            "阴道",
            "直肠",
            "迟钝",
            "连环画",
            "旋转",
            "s hit",
            "绍乙.",
            "虐待狂",
            "长",
            "划伤",
            "切开",
            "精液",
            "性别",
            "嘘 +",
            "嘘",
            "小时",
            "萨格",
            "抖动",
            "变形",
            "做爱",
            "女同性恋",
            "shi+ 键",
            "拉屎了",
            "屎东西",
            "乱七八糟",
            "大便师",
            "乱七八糟的",
            "荡妇",
            "斯迈格马",
            "闪烁",
            "抢",
            "沉积",
            "t1tt1e5 键",
            "吨数",
            "垫子",
            "泰兹语name",
            "测试",
            "睾丸",
            "奶头",
            "奶头5",
            "奶妈",
            "掷掷器",
            "tw4吨级",
            "wa",
            "wa头",
            "watt",
            "v14gra (英语)",
            "v1 颜色",
            "via草",
            "转数",
            "黄",
            "闲着",
            "虚无",
            "妇人",
            "威尔",
        ],
    ],
]);
//# sourceMappingURL=profane-words.js.map